package com.sweetlime.bingeamigo.presentation.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Visibility
import androidx.compose.material.icons.outlined.Visibility
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.sweetlime.bingeamigo.model.LibraryTvShow
import com.sweetlime.bingeamigo.presentation.features.library.TvLibraryViewModel
import com.sweetlime.bingeamigo.presentation.ui.BrandColors
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun TvTrackingButton(
    libraryTvShow: LibraryTvShow,
    viewModel: TvLibraryViewModel = koinViewModel()
) {
    val tracking by viewModel.tracking.collectAsState()
    val uiState by viewModel.uiState.collectAsState()
    val isTracking = tracking.any { it.id == libraryTvShow.id }
    var isLoading by remember { mutableStateOf(false) }

    LaunchedEffect(isTracking) { isLoading = false }
    LaunchedEffect(uiState) {
        if (uiState is com.sweetlime.bingeamigo.state.LibraryUiState.Error) {
            isLoading = false
            viewModel.clearError()
        }
    }

    Button(
        modifier = Modifier.fillMaxWidth(),
        onClick = {
            if (isLoading) return@Button
            isLoading = true
            if (isTracking) viewModel.removeFromTracking(libraryTvShow)
            else viewModel.addToTracking(libraryTvShow)
        },
        colors = if (isTracking)
            ButtonDefaults.buttonColors(containerColor = BrandColors.Secondary, contentColor = Color.White)
        else
            ButtonDefaults.buttonColors(containerColor = Color.Transparent, contentColor = Color.White),
        border = if (!isTracking) BorderStroke(1.dp, Color.White.copy(alpha = 0.4f)) else null
    ) {
        when {
            isLoading -> CircularProgressIndicator(modifier = Modifier.size(18.dp), strokeWidth = 2.dp, color = Color.White)
            isTracking -> Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
                Icon(Icons.Filled.Visibility, contentDescription = null)
                Spacer(Modifier.width(6.dp))
                Text("Tracking")
            }
            else -> Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
                Icon(Icons.Outlined.Visibility, contentDescription = null)
                Spacer(Modifier.width(6.dp))
                Text("Track")
            }
        }
    }
}
